const actions = {
  GET_TABLES_OVERVIEW_REQUEST: "GET_TABLES_OVERVIEW_REQUEST",
  GET_TABLES_OVERVIEW_SUCCESS: "GET_TABLES_OVERVIEW_SUCCESS",
  GET_DAILY_TURNOVER_REQUEST: "GET_DAILY_TURNOVER_REQUEST",
  GET_DAILY_TURNOVER_SUCCESS: "GET_DAILY_TURNOVER_SUCCESS",

  GET_DAILY_TURNOVER_FOR_PAST_8_DAYS_BY_RESTAURANT_REQUEST:
    "GET_DAILY_TURNOVER_FOR_PAST_8_DAYS_BY_RESTAURANT_REQUEST",
  GET_DAILY_TURNOVER_FOR_PAST_8_DAYS_BY_RESTAURANT_SUCCESS:
    "GET_DAILY_TURNOVER_FOR_PAST_8_DAYS_BY_RESTAURANT_SUCCESS",

  getTablesOverview: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_TABLES_OVERVIEW_REQUEST,
      });
    };
  },

  getDailyTurnOver: (startDate, endDate) => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_DAILY_TURNOVER_REQUEST,
        startDate,
        endDate,
      });
    };
  },

  getDailyTurnoverForPast8DaysByRestaurants: () => {
    return (dispatch) => {
      dispatch({
        type: actions.GET_DAILY_TURNOVER_FOR_PAST_8_DAYS_BY_RESTAURANT_REQUEST,
      });
    };
  },
};
export default actions;
